import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelOpenAccount, saveOpenAccount } from '../actions.js';

export function renderOpenAccountModal() {
  const s = getState();
  if (!s.showOpenAccount) return null;
  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'Open account'),
      h('input', {
        placeholder: 'Account name', value: s.newAcctName,
        oninput: (e) => setSilent({ newAcctName: e.target.value }),
        onkeydown: (e) => { if (e.key === 'Enter') saveOpenAccount(); }
      }),
      h('input', {
        placeholder: 'Owner (optional)', value: s.newAcctOwner,
        oninput: (e) => setSilent({ newAcctOwner: e.target.value }),
        onkeydown: (e) => { if (e.key === 'Enter') saveOpenAccount(); }
      }),
      h('div', { class: 'field-error' }, s.newAcctError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelOpenAccount }, 'Cancel'),
        h('button', { class: 'btn btn-primary', onclick: saveOpenAccount }, 'Open')
      ])
    ])
  ]);
}
